import { render } from "./App.vue?vue&type=template&id=b104ed80"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b104ed80&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\scheduler\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__